import { useQuery } from '@tanstack/react-query'
import { dashboardApi } from '../api/dashboard.api'

export function useCourseProgress(courseId: string) {
  return useQuery({
    queryKey: ['course-progress', courseId],
    queryFn: () => dashboardApi.fetchCourseProgress(courseId).then((r) => r.data.data),
    enabled: !!courseId,
  })
}
